import { createTheme } from '@mui/material/styles';

import { BASE_SPACING } from '../constants';

const theme = createTheme({
  spacing: BASE_SPACING,
});

export const getContrastText = (color: string) => {
  return theme.palette.getContrastText(color);
};

export const getSpacing = theme.spacing;
